import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react';
import MasterLayout from '../../../masterLayout/MasterLayout';
import Breadcrumb from '../../../components/Breadcrumb';
import { AppButton } from '../../../components/ui';
import { ROUTES } from '../../../config/routes';

const ADMIN_SECTIONS = [
  {
    title: 'Secteurs',
    description: 'Groupes commerciaux de zones (communes)',
    icon: 'mdi:map-marker-multiple',
    color: 'primary',
    to: ROUTES.secteurs.adminSecteurs,
  },
  {
    title: 'Zones',
    description: 'Délimitations des communes et attribution aux secteurs',
    icon: 'mdi:vector-polygon',
    color: 'info',
    to: ROUTES.secteurs.adminZones,
  },
  {
    title: 'Commerciaux',
    description: 'Correspondance email / nom / téléphone des commerciaux',
    icon: 'mdi:account-tie',
    color: 'success',
    to: ROUTES.admin.commerciaux,
  },
  {
    title: 'Entreprises HubSpot',
    description: 'Comptes clients importés depuis HubSpot',
    icon: 'mdi:office-building',
    color: 'warning',
    to: ROUTES.secteurs.adminEntreprises,
  },
  {
    title: 'Mappings produit → société',
    description: 'Correspondance produits Dolibarr / société (ITI, KKP…)',
    icon: 'mdi:tag-multiple',
    color: 'danger',
    to: ROUTES.secteurs.adminProduitsSociete,
  },
  {
    title: 'Produits par secteur',
    description: 'Répartition des produits par secteur géographique',
    icon: 'mdi:chart-bar',
    color: 'primary',
    to: ROUTES.secteurs.adminProduits,
  },
  {
    title: 'Produits par commerciaux',
    description: 'CA par société (ITI, KKP) et par vendeur',
    icon: 'mdi:chart-pie',
    color: 'info',
    to: ROUTES.secteurs.adminProduitsCommerciaux,
  },
  {
    title: 'Produits par entreprises',
    description: 'Entreprises clients avec produits par société de service',
    icon: 'mdi:domain',
    color: 'warning',
    to: ROUTES.secteurs.adminEntreprisesProduits,
  },
  {
    title: 'Commandes Dolibarr',
    description: 'Dernières commandes synchronisées',
    icon: 'mdi:cart',
    color: 'secondary',
    to: ROUTES.secteurs.adminCommandes,
  },
];

const SecteursAdminHubPage = () => (
  <MasterLayout>
    <Breadcrumb
      title="Administration Secteurs"
      subtitle="Configuration des territoires, commerciaux et mappings Dolibarr"
    />

    <div className="row g-3">
      {ADMIN_SECTIONS.map((section) => (
        <div key={section.title} className="col-md-6 col-lg-4">
          <Link to={section.to} className="text-decoration-none">
            <div className={`card h-100 border-0 shadow-sm hover-shadow transition`}>
              <div className="card-body d-flex gap-3">
                <div
                  className={`w-48-px h-48-px rounded-circle d-flex align-items-center justify-content-center bg-${section.color}-50 text-${section.color}-600 flex-shrink-0`}
                >
                  <Icon icon={section.icon} width={24} />
                </div>
                <div>
                  <h6 className="fw-semibold mb-1 text-dark">{section.title}</h6>
                  <p className="text-secondary-light text-sm mb-0">{section.description}</p>
                </div>
              </div>
            </div>
          </Link>
        </div>
      ))}
    </div>

    <div className="mt-4">
      <AppButton as={Link} to={ROUTES.secteurs.dashboard} size="sm" variant="outline-secondary" icon="mdi:arrow-left">
        Retour au dashboard
      </AppButton>
    </div>
  </MasterLayout>
);

export default SecteursAdminHubPage;
